(function () {
  const MIN_ZOOM = 10;
  const MAX_ZOOM = 20;

  function getZoom(src) {
    const match = src.match(/[?&]z=(\d+)/i);
    return match ? parseInt(match[1], 10) : null;
  }

  function setZoom(src, zoom) {
    if (/[?&]z=\d+/i.test(src)) {
      return src.replace(/([?&]z=)\d+/i, '$1' + zoom);
    }
    const separator = src.includes('?') ? '&' : '?';
    return src + separator + 'z=' + zoom;
  }

  function initMapZoom(root) {
    if (root.dataset.zoomEnabled === 'false') return;

    const iframe = root.querySelector('[data-contact-map-iframe]');
    const zoomIn = root.querySelector('[data-map-zoom-in]');
    const zoomOut = root.querySelector('[data-map-zoom-out]');
    if (!iframe || !zoomIn || !zoomOut) return;

    let zoom = getZoom(iframe.src);
    if (zoom === null) {
      zoom = parseInt(root.dataset.defaultZoom || '16', 10);
    }

    const applyZoom = (nextZoom) => {
      zoom = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, nextZoom));
      iframe.src = setZoom(iframe.src, zoom);
      zoomIn.disabled = zoom >= MAX_ZOOM;
      zoomOut.disabled = zoom <= MIN_ZOOM;
    };

    zoomIn.addEventListener('click', () => applyZoom(zoom + 1));
    zoomOut.addEventListener('click', () => applyZoom(zoom - 1));

    applyZoom(zoom);
  }

  function boot() {
    document.querySelectorAll('[data-contact-map]').forEach(initMapZoom);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
